const BASE_PHONE_OPTIONS = [
  '010-127 12 60',
  '010-127 12 61',
  '010-127 12 62',
  '010-127 12 80 Pebberholmen',
  '010-127 12 32',
  '010-127 12 42',
  '010-127 12 41',
  '010-127 42 35 Borlänge',
  '010-127 42 24',
  '010-127 42 25',
];

const normalizeDistrictKey = (value = '') =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const DISTRICT_CONTACTS = {
  malmo: {
    emergency: '010-127 12 99 Malmö',
    bandrift: '010-127 10 20',
    eldrift: '010-127 02 30',
  },
  gavle: {
    emergency: '010-127 42 99 Gävle',
    bandrift: '010-127 40 20',
    eldrift: '010-127 01 30',
  },
  goteborg: {
    emergency: '010-127 22 99 Göteborg',
    bandrift: '010-127 20 20',
    eldrift: '010-127 02 20',
  },
  hallsberg: {
    emergency: '010-127 45 99 Hallsberg',
    bandrift: '010-127 40 25',
    eldrift: '010-127 01 60',
  },
  norrkoping: {
    emergency: '010-127 33 99 Norrköping',
    bandrift: '010-127 30 21',
    eldrift: '010-127 02 10',
  },
  stockholm: {
    emergency: '010-127 32 99 Stockholm',
    bandrift: '010-127 30 20',
    eldrift: '010-127 01 40 N / 010-127 01 50 S',
  },
  ange: {
    emergency: '010-127 43 99 Ånge',
    bandrift: '010-127 40 24',
    eldrift: '010-127 01 20',
  },
  boden: {
    emergency: '010-127 44 99 Boden',
    bandrift: '010-127 40 23',
    eldrift: '010-127 01 10',
  },
  'goteborg stockholm': {
    emergency: '',
    bandrift: '',
    eldrift: '',
  },
};

const MALMO_RULES = [
  {
    phone: '010-127 12 32',
    keywords: ['hassleholm', 'hm'],
    minScore: 1,
  },
  {
    phone: '010-127 12 62',
    keywords: ['helsingborg', 'hbgb', 'helsingborg central'],
    minScore: 1,
  },
  {
    phone: '010-127 12 60',
    keywords: ['helsingborg', 'kattarp', 'angelholm', 'eldsberga', 'halmstad'],
    minScore: 2,
  },
  {
    phone: '010-127 12 61',
    keywords: [
      'helsingborg',
      'gantofta',
      'vallakra',
      'tagarp',
      'billeberga',
      'teckomatorp',
      'eslov',
      'kavlinge',
      'arlov',
      'lund',
      'malmo',
      'hyllie',
      'fosieby',
      'ostervarn',
    ],
    minScore: 2,
  },
  {
    phone: '010-127 12 42',
    keywords: [
      'helsingborg',
      'astorp',
      'bjuv',
      'teckomatorp',
      'svalov',
      'kvidinge',
      'klippan',
      'perstorp',
      'hassleholm',
    ],
    minScore: 2,
  },
  {
    phone: '010-127 12 41',
    keywords: ['kristianstad', 'crgb'],
    minScore: 1,
  },
];

const normalizeCatalogText = (value = '') =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const splitCatalogTokens = (value = '') =>
  normalizeCatalogText(value)
    .split(/\s+/)
    .filter(Boolean);

export const fjtklPhoneOptions = BASE_PHONE_OPTIONS;

export const emergencyPhoneOptions = Array.from(
  new Set(
    Object.values(DISTRICT_CONTACTS)
      .map((entry) => entry.emergency)
      .filter(Boolean)
  )
);

export const bandriftPhoneOptions = Array.from(
  new Set(
    Object.values(DISTRICT_CONTACTS)
      .map((entry) => entry.bandrift)
      .filter(Boolean)
  )
);

export const eldriftPhoneOptions = Array.from(
  new Set(
    Object.values(DISTRICT_CONTACTS)
      .map((entry) => entry.eldrift)
      .filter(Boolean)
  )
);

export const getDistrictContactDefaults = (districtName = '') => {
  const normalized = normalizeDistrictKey(districtName);
  return DISTRICT_CONTACTS[normalized] || null;
};

export const getCatalogPhoneOptions = (extraOptions = []) =>
  Array.from(new Set([...BASE_PHONE_OPTIONS, ...extraOptions].filter(Boolean)));

export const matchFjtklPhoneFromCatalog = ({
  projectName = '',
  plats = '',
  granspunkter = '',
  entry = null,
} = {}) => {
  const haystack = [
    projectName,
    plats,
    granspunkter,
    entry?.beteckning || '',
    entry?.granspunkt || '',
  ].join(' ');

  const normalizedHaystack = normalizeCatalogText(haystack);
  const haystackTokens = new Set(splitCatalogTokens(haystack));

  let bestMatch = null;

  MALMO_RULES.forEach((rule) => {
    const matchedKeywords = rule.keywords.filter((keyword) => {
      const normalizedKeyword = normalizeCatalogText(keyword);
      return normalizedHaystack.includes(normalizedKeyword) || haystackTokens.has(normalizedKeyword);
    });

    if (matchedKeywords.length < (rule.minScore || 1)) {
      return;
    }

    const candidate = {
      phone: rule.phone,
      matchedKeywords,
      score: matchedKeywords.length,
    };

    if (!bestMatch || candidate.score > bestMatch.score) {
      bestMatch = candidate;
    }
  });

  return bestMatch;
};
